<template>
  <v-form>
    <v-container fluid>
      <v-row dense>
        <v-col
          cols="12"
          sm="12"
          v-if="this.isIndividuallyBookable"
        >
          <v-checkbox
            :label="$t('guestBooking')"
            v-model="enableGuestBooking"
          />
        </v-col>
      </v-row>
      <v-row
        v-if="this.isIndividuallyBookable && this.enableGuestBooking === false"
        dense
      >
        <v-col
          cols="12"
          sm="12"
        >
          <CustomerSearch
            v-if="currentCustomer === null"
            :on-selected="onCustomerAcUpdated"
            :required="true"
          />
          <v-chip v-else>
            {{ currentCustomer.customerNumber }}:
            {{ getProfileItemBasics(currentCustomer.profile, 'firstName') }}
            {{ getProfileItemBasics(currentCustomer.profile, 'lastName') }}
            <template v-if="getProfileItemBasics(currentCustomer.profile, 'company')">
              | {{ getProfileItemBasics(currentCustomer.profile, 'company') }}
            </template>
          </v-chip>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-text-field
            v-if="this.enabledNameAndMail"
            :error-messages="nameErrors"
            :label="$t('ParticipantName')"
            @blur="$v.item.name.$touch()"
            @input="$v.item.name.$touch()"
            v-model="item.name"
            :disabled="!this.enabledNameAndMail"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col
          v-if="this.isIndividuallyBookable && this.enableGuestBooking === true"
          cols="12"
          md="6"
          sm="6"
        >
          <v-select
            :items="salutationItems"
            :error-messages="guestSalutationErrors"
            :label="$t('salutation')"
            @blur="$v.item.profile.salutation.$touch()"
            @input="$v.item.profile.salutation.$touch()"
            v-model="item.profile.salutation"
          />
        </v-col>
      </v-row>
      <v-row
        v-if="this.isIndividuallyBookable && this.enableGuestBooking === true"
        dense
      >
        <v-col
          cols="12"
          md="6"
          sm="6"
        >
          <v-text-field
            :error-messages="guestFirstNameErrors"
            :label="$t('firstName')"
            @blur="$v.item.profile.firstName.$touch()"
            @input="$v.item.profile.firstName.$touch()"
            required
            v-model="item.profile.firstName"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
          sm="6"
        >
          <v-text-field
            :error-messages="guestLastNameErrors"
            :label="$t('lastName')"
            @blur="$v.item.profile.lastName.$touch()"
            @input="$v.item.profile.lastName.$touch()"
            v-model="item.profile.lastName"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-text-field
            v-if="this.enabledNameAndMail || this.enableGuestBooking"
            :error-messages="emailErrors"
            :label="$t('email')"
            @blur="$v.item.email.$touch()"
            @input="$v.item.email.$touch()"
            v-model="item.email"
            :disabled="!this.enabledNameAndMail && !this.enableGuestBooking"
          />
        </v-col>
      </v-row>
      <v-row
        v-if="this.isIndividuallyBookable && this.enableGuestBooking === true"
        dense
      >
        <v-col cols="12">
          <v-text-field
            :error-messages="guestCompanyErrors"
            :label="$t('company')"
            @blur="$v.item.profile.company.$touch()"
            @input="$v.item.profile.company.$touch()"
            v-model="item.profile.company"
          />
        </v-col>
        <v-col
          cols="12"
          v-if="item.profile.addresses && item.profile.addresses.length"
        >
          <v-text-field
            :error-messages="guestAdditionalErrors"
            :label="$t('additional')"
            @blur="$v.item.profile.addresses[0].additional.$touch()"
            @input="$v.item.profile.addresses[0].additional.$touch()"
            v-model="item.profile.addresses[0].additional"
          />
        </v-col>
        <v-col
          cols="12"
          v-if="item.profile.addresses && item.profile.addresses.length"
        >
          <v-text-field
            :error-messages="guestStreetNrErrors"
            :label="$t('streetNr')"
            @blur="$v.item.profile.addresses[0].streetNr.$touch()"
            @input="$v.item.profile.addresses[0].streetNr.$touch()"
            v-model="item.profile.addresses[0].streetNr"
          />
        </v-col>
        <v-col
          cols="4"
          v-if="item.profile.addresses && item.profile.addresses.length"
        >
          <v-text-field
            :error-messages="guestZipCodeErrors"
            :label="$t('zipCode')"
            @blur="$v.item.profile.addresses[0].zipCode.$touch()"
            @input="$v.item.profile.addresses[0].zipCode.$touch()"
            v-model="item.profile.addresses[0].zipCode"
          />
        </v-col>
        <v-col
          cols="8"
          v-if="item.profile.addresses && item.profile.addresses.length"
        >
          <v-text-field
            :error-messages="guestCityErrors"
            :label="$t('city')"
            @blur="$v.item.profile.addresses[0].city.$touch()"
            @input="$v.item.profile.addresses[0].city.$touch()"
            v-model="item.profile.addresses[0].city"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-text-field
            v-if="efnRequired"
            :error-messages="efnErrors"
            :label="$t('efn')"
            @blur="$v.item.efn.$touch()"
            @input="$v.item.efn.$touch()"
            v-model="item.efn"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            :error-messages="commentErrors"
            :label="$t('comment')"
            @blur="$v.item.comment.$touch()"
            @input="$v.item.comment.$touch()"
            v-model="item.comment"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
  import has from 'lodash/has';
  import { validationMixin } from 'vuelidate';
  import { email, requiredIf, numeric, minLength, maxLength } from 'vuelidate/lib/validators';
  import TenantMixin from '../../mixins/TenantMixin';
  import ProfileMixin from '@/mixins/ProfileMixin';
  import CustomerMixin from '@/mixins/CustomerMixin';
  import CustomerSearch from '@/components/customer/Search.vue';

  export default {
    name: 'ParticipantForm',
    components: { CustomerSearch },
    mixins: [validationMixin, TenantMixin, ProfileMixin, CustomerMixin],
    props: {
      values: {
        type: Object,
        required: true
      },
      currentParticipants: {
        type: Array,
        required: false
      },
      isNoOnline: {
        type: Boolean,
        default: false,
        required: false
      },
      errors: {
        type: Object,
        default: () => { }
      },
      initialValues: {
        type: Object,
        default: () => { }
      },
      currentCustomer: {
        type: Object,
        default: () => null
      },
      efnRequired: {
        type: Boolean,
        default: false,
        required: false
      },
    },
    data() {
      return {
        currentSelectedCustomer: null,
        enableGuestBooking: false,
        salutationItems: ["Frau", "Herr", "Divers"],
      };
    },
    computed: {
      item() {
        return this.initialValues || this.values;
      },
      currentCustomerObject: {
        get() {
          return this.currentCustomer
        },
        set(currentCustomer) {
          return currentCustomer
        }
      },
      enabledNameAndMail() {
        return !this.isIndividuallyBookable || this.currentSelectedCustomer?.isBusiness;
      },
      nameErrors() {
        const errors = [];
        if (this.$v.item.name) {
          if (!this.$v.item.name.$dirty) {
            return errors;
          }

          has(this.violations, 'name') && errors.push(this.violations.name);

          !this.$v.item.name.required && errors.push(this.$t('Field is required'));
        }
        return errors;
      },
      emailErrors() {
        const errors = [];
        if (this.$v.item.email) {
          if (!this.$v.item.email.$dirty) {
            return errors;
          }

          has(this.violations, 'email') && errors.push(this.violations.email);

          !this.$v.item.email.required && errors.push(this.$t('Field is required'));
          !this.$v.item.email.email && errors.push(this.$t('Invalid email address.'));
        }
        return errors;
      },
      efnErrors() {
        const errors = [];
        if (this.$v.item.efn) {
          if (!this.$v.item.efn.$dirty) {
            return errors;
          }

          has(this.violations, 'efn') && errors.push(this.violations.efn);
          !this.$v.item.efn.required && errors.push(this.$t('Field is required'));
          !this.$v.item.efn.maxLength && errors.push(this.$t('efnLengthViolation'));
          !this.$v.item.efn.minLength && errors.push(this.$t('efnLengthViolation'));
          !this.$v.item.efn.numeric && errors.push(this.$t('efnLengthViolationNumeric'));
        }
        return errors;
      },
      commentErrors() {
        const errors = [];
        if (this.$v.item.comment) {
          if (!this.$v.item.comment.$dirty) {
            return errors;
          }

          has(this.violations, 'comment') && errors.push(this.violations.comment);
        }
        return errors;
      },
      guestSalutationErrors() {
        const errors = [];
        if (this.$v.item.profile.salutation) {
          if (!this.$v.item.profile.salutation.$dirty) {
            return errors;
          }

          has(this.violations, 'profile.salutation') && errors.push(this.violations['profile.salutation']);

          !this.$v.item.profile.salutation.required && errors.push(this.$t('Field is required'));
        }
        return errors;
      },
      guestFirstNameErrors() {
        const errors = [];
        if (this.$v.item.profile.firstName) {
          if (!this.$v.item.profile.firstName.$dirty) {
            return errors;
          }

          has(this.violations, 'profile.firstName') && errors.push(this.violations['profile.firstName']);

          !this.$v.item.profile.firstName.required && errors.push(this.$t('Field is required'));
        }
        return errors;
      },
      guestLastNameErrors() {
        const errors = [];
        if (this.$v.item.profile.lastName) {
          if (!this.$v.item.profile.lastName.$dirty) {
            return errors;
          }

          has(this.violations, 'profile.lastName') && errors.push(this.violations['profile.lastName']);

          !this.$v.item.profile.lastName.required && errors.push(this.$t('Field is required'));
        }
        return errors;
      },
      guestStreetNrErrors() {
        const errors = [];
        if (this.$v.item.profile.addresses[0].streetNr) {
          if (!this.$v.item.profile.addresses[0].streetNr.$dirty) {
            return errors;
          }
          has(this.violations, 'profile.addresses[0].streetNr') && errors.push(this.violations['profile.addresses[0].streetNr']);
          !this.$v.item.profile.addresses[0].streetNr.required && errors.push('Required');
        }
        return errors;
      },
      guestZipCodeErrors() {
        const errors = [];
        if (this.$v.item.profile.addresses[0].zipCode) {
          if (!this.$v.item.profile.addresses[0].zipCode.$dirty) {
            return errors;
          }
          has(this.violations, 'profile.addresses[0].zipCode') && errors.push(this.violations['profile.addresses[0].zipCode']);
          !this.$v.item.profile.addresses[0].zipCode.required && errors.push('Required');
        }
        return errors;
      },
      guestCityErrors() {
        const errors = [];
        if (this.$v.item.profile.addresses[0].city) {
          if (!this.$v.item.profile.addresses[0].city.$dirty) {
            return errors;
          }
          has(this.violations, 'profile.addresses[0].city') && errors.push(this.violations['profile.addresses[0].city']);
          !this.$v.item.profile.addresses[0].city.required && errors.push('Required');
        }
        return errors;
      },
      guestAdditionalErrors() {
        const errors = [];
        if (this.$v.item.profile.addresses[0].additional) {
          if (!this.$v.item.profile.addresses[0].additional.$dirty) {
            return errors;
          }
          has(this.violations, 'profile.addresses[0].additional') && errors.push(this.violations['profile.addresses[0].additional']);
        }
        return errors;
      },
      guestCompanyErrors() {
        const errors = [];
        if (this.$v.item.profile.company) {
          if (!this.$v.item.profile.company.$dirty) {
            return errors;
          }

          has(this.violations, 'profile.company') && errors.push(this.violations['profile.company']);
        }
        return errors;
      },
      violations() {
        return this.errors || {};
      },
      isIndividuallyBookable() {
        return this.currentSeminarSettings['individuallyBookable'];
      }
    },
    methods: {
      log(message) {
        console.log(message);
      },
      onCustomerAcUpdated(selectedCustomer) {
        this.$emit('selectedCustomer', selectedCustomer);
        if (selectedCustomer) {
          this.item.customer = selectedCustomer['@id'];
          this.currentSelectedCustomer = selectedCustomer;
        } else {
          this.item.customer = null;
          this.currentSelectedCustomer = null;
        }
      }
    },
    validations: {
      item: {
        customer: {
          required: requiredIf(function () {
            return this.isIndividuallyBookable && this.enableGuestBooking === false;
          })
        },
        profile: {
          salutation: {
            required: requiredIf(function () {
              return this.isIndividuallyBookable && this.enableGuestBooking === true;
            })
          },
          firstName: {
            required: requiredIf(function () {
              return this.isIndividuallyBookable && this.enableGuestBooking === true;
            })
          },
          lastName: {
            required: requiredIf(function () {
              return this.isIndividuallyBookable && this.enableGuestBooking === true;
            })
          },
          addresses: {
            0: {
              additional: {},
              streetNr: {
                required: requiredIf(function () {
                  return this.isIndividuallyBookable && this.enableGuestBooking === true;
                })
              },
              zipCode: {
                required: requiredIf(function () {
                  return this.isIndividuallyBookable && this.enableGuestBooking === true;
                })
              },
              city: {
                required: requiredIf(function () {
                  return this.isIndividuallyBookable && this.enableGuestBooking === true;
                })
              },
            }
          },
          company: {},
        },
        name: {
          required: requiredIf(function () {
            return this.enabledNameAndMail;
          })
        },
        email: {
          email,
          required: requiredIf(function () {
            return !this.isIndividuallyBookable && !this.isNoOnline;
          })
        },
        comment: {},
        efn: {
          numeric,
          required: requiredIf(function () {
            return this.efnRequired;
          }),
          minLength: minLength(15),
          maxLength: maxLength(15),
        }
      }
    },
    watch: {
      enableGuestBooking: {
        immediate: true,
        handler() {
          if (!this.enableGuestBooking) {
            this.item.profile = null;
            this.item.guest = false;
            return;
          }
          this.item.customer = null;
          this.item.guest = true;
          this.item.profile = this.item.profile || {};
          this.item.profile.addresses = [{
            type: 'default',
            additional: null,
            streetNr: null,
            zipCode: null,
            city: null,
            country: 'DE',
          }];
        },
      },
      'item.profile.firstName'() {
        if (this.enableGuestBooking === false) {
          return;
        }
        this.item.name = this.item.profile.firstName + ' ' + this.item.profile.lastName;
      },
      'item.profile.lastName'() {
        if (this.enableGuestBooking === false) {
          return;
        }
        this.item.name = this.item.profile.firstName + ' ' + this.item.profile.lastName;
      },
    }
  };
</script>
